import { useSelector } from "react-redux";

/* Tema basado en Cielo, para evitar errores a nivel consola de themes */
const defaultThemeColors = {
  palette: {
    primary: {
      main: "#336699",
      light: "#6693ca",
      dark: "#003c6b",
    },
    secondary: {
      main: "#6699cc",
      light: "#98caff",
      dark: "#326b9b",
    },
  },
};

const isLoaded = (uiConfig) => {
  return uiConfig && uiConfig.primary && uiConfig.secondary;
};

export const ColorPalette = () => {
  const { uiConfig } = useSelector((state) => state.local);
  const colorPalette = {
    palette: {
      primary: {
        main: uiConfig?.primary?.main,
        light: uiConfig?.primary?.light,
        dark: uiConfig?.primary?.dark,
      },
      noa: {
        main: "#CC99BD",
        light: "#FFCC33",
        dark: "#FFFFFF",
        secondary: "#9D9D9C",
      },
      purple: {
        main: "#9999CC",
        secondary: "#9999CC",
        dark: "#9999CC",
        light: "#9999CC",
      },
      secondary: {
        main: uiConfig?.secondary?.main,
        light: uiConfig?.secondary?.light,
        dark: uiConfig?.secondary?.dark,
      },
    },
  };
  return isLoaded(uiConfig) ? colorPalette : defaultThemeColors;
};
